export default __webpack_public_path__ + "static/media/1798.2dd7c490.png";